/**
 *  @typedef {import('../../../interfaces/models/IPersonaImplicada.interface').IPersonaImplicada} IPersonaImplicada
 */

import React, { useEffect } from 'react';
import { arrayOf, bool, shape } from 'prop-types';
import AUIButton from '@ancert/aui-button';
import { AUITable } from '@ancert/aui-table';
import { usePersonasImplicadas } from '../../../context/personasImplicadas.context';
import getColumns from './columns';
import { PAGE_SIZE } from '../../../config';
import { useFormularDenuncia } from '../../../context/formularDenuncia.context';

const PersonasImplicadas = ({ personas, viewMode }) => {
  const { addPersonaImplicada, eliminarPersonaImplicada, personasImplicadas } = useFormularDenuncia();
  const { personaImplicada, openModal, onEdit, onVer } = usePersonasImplicadas();
  useEffect(() => {
    if (personaImplicada) {
      addPersonaImplicada(personaImplicada);
    }
  }, [personaImplicada]);
  /**
   *
   * @param {IPersonaImplicada} data
   */
  const onRowEditar = (data) => {
    onEdit(data);
  };

  /**
   *
   * @param {IPersonaImplicada} data
   */
  const onRowVer = (data) => {
    onEdit(data);
    onVer();
  };

  /**
   *
   * @param {object} param
   * @param {number} param.id
   */
  const onRowEliminar = ({ id }) => {
    eliminarPersonaImplicada(id);
  };

  return (
    <div className="c-sii-personas-implicadas u-mt-32">
      <h3 className="c-sii-title-action">
        Personas implicadas en el hecho{' '}
        {!viewMode && <AUIButton label="Añadir persona" mode="secondary" onClick={openModal} />}
      </h3>
      <AUITable
        columns={getColumns({ onRowEditar, onRowEliminar, onRowVer }, viewMode)}
        data={personas.length === 0 ? personasImplicadas : personas}
        pageSize={PAGE_SIZE.PERSONAS_IMPLICADAS}
        noDataText="No existen personas implicadas en la comunicación"
      />
    </div>
  );
};
PersonasImplicadas.propTypes = {
  personas: arrayOf(shape({})),
  viewMode: bool,
};
PersonasImplicadas.defaultProps = {
  personas: [],
  viewMode: false,
};

export default PersonasImplicadas;
